import React, { createContext, useContext, useEffect, useState } from 'react';
import { ref, onValue, off, getDatabase } from 'firebase/database';
import { core } from '../../../Firebase/init';

export const realtimeDb = getDatabase(core);

function isDateInPast(date) {
    const now = new Date();
    return date < now;
}

function isSaleActive(sale) {
    if (sale?.ed) {
        try {
            const endDate = new Date(sale.ed);
            if (isDateInPast(endDate)) {
                return false;
            }
            return true;
        } catch (error) {
            return false;
        }
    } else {
        return true;
    }
}

const PriceContext = createContext(null);

const PriceProvider = ({ children }) => {
    const [prices, setPrices] = useState(null);
    const [sales, setSales] = useState(null);
    const [salesLoaded, setSalesLoaded] = useState(false);

    const isThereValidSale = () => {
        return Boolean(sales && Object.keys(sales).length !== 0);
    };

    useEffect(() => {
        const salesRef = ref(realtimeDb, "sales/g");
        const pricesRef = ref(realtimeDb, "prices/");

        onValue(pricesRef, (snapshot) => {
            const data = snapshot.val();
            setPrices(data);
        });

        onValue(salesRef, (snapshot) => {
            const data = snapshot.val();

            if (isSaleActive(data)) {
                setSales(data);
            } else {
                setSales(null);
            }
            setSalesLoaded(true);
        });

        return () => {
            off(pricesRef);
            off(salesRef);
        };
    }, []);


    return (
        <PriceContext.Provider value={{
            prices,
            sales,
            isSale: isThereValidSale(),
            salesLoaded
        }}>
            {children}
        </PriceContext.Provider>
    );
};

export default React.memo(PriceProvider);

export const usePrice = () => useContext(PriceContext);
